import { defaultsDeep } from "lodash";
import { DeepNullableObj, PatientNeeds } from "../types";
import { MockFn, createMock } from "./index";

const mockPatientNeeds: MockFn<Partial<DeepNullableObj<PatientNeeds>>> = (
  args,
) =>
  defaultsDeep(
    args,
    createMock(
      "PatientNeeds",
      args,
      (): DeepNullableObj<PatientNeeds> => ({
        access_drainages: {
          central_venous_catheter: null,
          drainage: null,
          gastric_tube: null,
          intravenous_injection: null,
          other_access_drainages: null,
          peripheral_venous_catheter: null,
          permanent_catheter: null,
          suprapubic_catheter: null,
          tracheal_cannula: null,
        },
        base_care: { companionship_grant: null, description: null },
        basic_medical_care: { description: null },
        breathing: {
          oxygen_therapy: null,
          specialised_intensive_nurse: null,
          tracheostomy: null,
        },
        care_for_children_and_teenagers: { description: null },
        care_for_youth: { description: null },
        companionship: { companionship_grant: null, description: null },
        compression: { description: null },
        daily_activities: { description: null },
        dialysis: { hemodialysis: null, peritoneal_dialysis: null },
        food: { food_help: null, meals: null },
        help_at_home: { description: null },
        important_information: null,
        incontinence: {
          fecal_incontinence: null,
          incontinence_help_type: null,
          requires_material_supplies: null,
          urinary_incontinence: null,
        },
        injection: { description: null },
        integration_assistance: { description: null },
        medication: { blood_thinner: null, description: null },
        monitoring: { circulation: null, metabolism: null, respiration: null },
        nutrition: { enteral_nutrition: null, parenteral_nutrition: null },
        palliative: { description: null, palliative_certificate_needed: null },
        psychiatric_care: { description: null },
        psychiatric_home_nursing: { description: null },
        remarks: null,
        sociotherapy: { description: null },
        static_care_disabled_patients: { description: null },
        substitute_offers: { description: null },
        support: { body_care: null, dressing: null, eating: null },
        wound_care: { description: null },
      }),
    ),
  );

export default mockPatientNeeds;
